<template>
<div style="width: 100%; height: 100%;">
    <div id="chinaMap" style="width: 90%; height: 100%;"></div>
</div>
</template>
<script>
import * as echarts from "echarts";
// import * as echarts from 'echarts/core';
// import { MapChart } from 'echarts/charts';  // 地图图表类型
// import { TooltipComponent, TitleComponent } from 'echarts/components';  // 提示框组件和标题组件
// import { CanvasRenderer } from 'echarts/renderers';  // 渲染器
import chinaJson from "@/assets/json/china.json"

// // 注册必须的组件
// echarts.use([MapChart, TooltipComponent, TitleComponent, CanvasRenderer]);
export default {
  name: "ChinaMap",
  props : {
    value : {
      type : Number,
      default : 0
    }
  },
  data() {
    return {
        mapName : 'china',
        data : [
            { name: '北京', value: 5 },
            { name: '天津', value: 14 },
            { name: '河北', value: 157 },
            { name: '山西', value: 110 },
            { name: '内蒙古', value: 40 },
            { name: '辽宁', value: 40 },
            { name: '吉林', value: 40 },
            { name: '黑龙江', value: 60 },
            { name: '上海', value: 10 },
            { name: '江苏', value: 60 },
            { name: '浙江', value: 50 },
            { name: '安徽', value: 151 },
            { name: '福建', value: 60 },
            { name: '江西', value: 74 },
            { name: '山东', value: 200 },
            { name: '河南', value: 100 },
            { name: '湖北', value: 40 },
            { name: '湖南', value: 50 },
            { name: '重庆', value: 40 },
            { name: '四川', value: 120 },
            { name: '贵州', value: 135 },
            { name: '云南', value: 90 },
            { name: '西藏', value: 25 },
            { name: '陕西', value: 100 },
            { name: '甘肃', value: 60 },
            { name: '青海', value: 20 },
            { name: '宁夏', value: 110 },
            { name: '新疆', value: 32 },
            { name: '广东', value: 10 },
            { name: '广西', value: 100 },
            { name: '海南', value: 40 },
        ],
        geoCoordMap : {
            '黑龙江': [127.9688, 45.368],
            '内蒙古': [110.3467, 40.4899],
            "吉林": [125.8154, 44.2584],
            '北京市': [116.4551, 40.2539],
            "辽宁": [123.1238, 42.1216],
            "河北": [114.4995, 38.1006],
            "天津": [117.4219, 39.4189],
            "山西": [112.3352, 37.9413],
            "陕西": [109.1162, 34.2004],
            "甘肃": [103.5901, 36.3043],
            "宁夏": [106.3586, 38.1775],
            "青海": [101.4038, 36.8207],
            "新疆": [87.611053, 43.828171],
            "西藏": [91.117212, 29.646922],
            "四川": [103.9526, 30.7617],
            "重庆": [108.384366, 30.439702],
            "山东": [117.1582, 36.8701],
            "河南": [113.4668, 34.6234],
            "江苏": [118.8062, 31.9208],
            "安徽": [117.29, 32.0581],
            "湖北": [114.3896, 30.6628],
            "浙江": [119.5313, 29.8773],
            "福建": [119.4543, 25.9222],
            "江西": [116.0046, 28.6633],
            "湖南": [113.0823, 28.2568],
            "贵州": [106.6992, 26.7682],
            "云南": [102.9199, 25.4663],
            "广东": [113.12244, 23.009505],
            "广西": [108.479, 23.1152],
            "海南省": [110.3893, 19.8516],
            "台湾": [120.702967, 24.123621],
            '上海': [121.4648, 31.2891]

        },
        toolTipData : [
            {
                name: '广东省',
                value: `<br><br><h4>深圳</h4>龙华分布（1,2,3号仓）<br>机场分布（机场中转仓）<br>观澜仓库（现代化一万平转运仓）<br><br>中山分公司<br>中山仓库<br><br>佛山分公司<br>佛山仓库<br><br>广州分公司<br>广州仓库<br><br>东莞分公司<br>东莞仓库`,
                areas: [],
            },
            {
                name: '福建省',
                value: `<br>厦门分公司<br>厦门仓库`,
                areas: [],
            },
            {
                name: '浙江省',
                value: `<br>宁波分公司<br>华东分拨中心<br>义乌分公司<br>义乌仓库`,
                areas: [],
            },
            {
                name: '上海市',
                value: `<br>上海分公司<br>上海仓库`,
                areas: [],
            },
            {
                name: '安徽省',
                value: `<br>合肥分公司<br>合肥仓库`,
                areas: [],
            },
            {
                name: '河南省',
                value: `<br>郑州分公司`,
                areas: [],
            },
            {
                name: '山东省',
                value: `<br>青岛分公司<br>华北分拨中心`,
                areas: [],
            },
            {
                name: '四川省',
                value: `<br>成都分公司`,
                areas: [],
            },
            {
                name: '新疆维吾尔自治区',
                value: `<br>塔城分公司<br>新疆阿拉山口<br>新疆霍尔果斯`,
                areas: [],
            },
        ],
        colorMap : {
            areaColor: 'rgba(0, 175, 175, 0.15)',
            borderColor: '#00AFAF'
        },
        flowData:[],
        emphasisData:[]
    };
  },
  mounted() {
    let myChart = echarts.init(document.querySelector("#chinaMap"));
    let _this = this
    this.getRegions()
 
    this.initChart(myChart,this.toolTipData)        
    myChart.showLoading();
        let mapFeatures = echarts.getMap(this.mapName).geoJson.features;
        myChart.hideLoading();
        // mapFeatures.forEach(function (v) {
        //     console.log(v.properties.name,_this.geoCoordMap[name]); 
        //     console.log(v.properties.center,v.properties.name,'23')
        //      // 地区名称
        //     // 地区经纬度
        //     mapFeatures.forEach(function(v) {
        //         for (let name in _this.geoCoordMap) {
        //             if (v.properties.name.includes(name)) {
        //             console.log(v.properties.name,name);

        //                 _this.geoCoordMap[name] = v.properties.center;
        //             }
        //         }
        //     });
          
        // });
        // 点击事件监听器
            myChart.on('click',  (params) =>{
                // console.log(params.name)
            });
            // 鼠标经过事件监听器
            myChart.on('mouseover',  (params)=> {
            });

  },
  methods: {
    initChart(myChart,toolTipData) {
              // 基于准备好的dom，初始化echarts实例
              echarts.registerMap("china",chinaJson);
              // 绘制图表
              // 指定图表的配置和数据
              let option = {
            backgroundColor: "#ffffff",
            title: {
                show: false,
                text: "项目分布图",
                x: 'center',
                top: "10",
                textStyle: {
                    color: "#d9f3f3",
                    fontFamily: "等线",
                    fontSize: 30,
                    fontWeight: 800,
                },
            },
            tooltip: {
                trigger: 'item',
                formatter: function (params) {
                    if (typeof params.value[2] == 'undefined' || !params.value) {
                        let toolTiphtml = '';
                        for (let i = 0; i < toolTipData.length; i++) {

                            if (params.name == toolTipData[i].name || params.name.includes(toolTipData[i].name) ) {
                                toolTiphtml += toolTipData[i].name + "：" + toolTipData[i].value;
                            }
                        }

                        // console.log(convertData(data))
                        return toolTiphtml;
                    } else {
                        let toolTiphtml = '';
                        for (let i = 0; i < toolTipData.length; i++) {
                            if (params.name == toolTipData[i].name) {
                                toolTiphtml += toolTipData[i].name + "：" + toolTipData[i].value;
                            }
                        }
                    
                        return toolTiphtml;
                    }
                },
                backgroundColor: "#fff",
                borderColor: "#fff",
                padding: [5, 10],
                textStyle: {
                    color: "#333",
                    fontSize: "16",
                    fontWeight: "bold"
                }
            },
            geo: [
                {
                layoutCenter: ['35%', '65%'],//位置
                layoutSize: '180%',//大小
                show: true,
                map: this.mapName,
                roam: false,
                zoom: 0.65,
                aspectScale: 0.8,
                regions: this.flowData,
                label: {
                    normal: {
                        show: false,
                        textStyle: {
                            color: '#f8f8f8'
                        }
                    },
                    emphasis: {
                        show: false,
                        textStyle: {
                            color: '#d9f3f3'
                        }
                    }
                },
                select: {
                      label: {
                        show: false,
                        color: '#fafafa'
                      },
                      itemStyle: {
                        areaColor: '#fafafa'
                      }
                  
                    },
                itemStyle: {
                    normal: {
                        areaColor: {
                            type: "linear",
                            x: 1200,
                            y: 0,
                            x2: 0,
                            y2: 0,
                            colorStops: [{
                                offset: 0,
                                color: "#fafafa", // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: "#fafafa", // 50% 处的颜色
                            },],
                            global: true, // 缺省为 false
                        },
                        borderColor: "#A6A6A6",
                        borderWidth: 1,
                    },
                    emphasis: {
                        show: true,
                        color: '#fafafa', //悬浮背景
                        // areaColor: "#d9f3f3",
                        areaColor: "#fafafa",
                         itemStyle: {
                             areaColor: "#fafafa", // 高亮时候地图显示的颜色
                             borderWidth: 1, // 高亮时的边框宽度
                           },
                         textStyle: {
                              color: '#fafafa'
                          }
                          // borderWidth: 0
                      }
                  
                
                }
            }
        ],
            series: [
                {
                    type: 'map',
                    map: this.mapName,
                    geoIndex: 0,
                    aspectScale: 1, //长宽比
                    zoom: 0.65,
                    showLegendSymbol: true,
                    roam: true,
                    label: {
                        normal: {
                            show: true,
                            textStyle: {
                                color: "#d9f3f3",
                                fontSize: "120%"
                            },
                        },
                        emphasis: {
                            show: false,
                        },
                    },
                    itemStyle: {
                        normal: {
                            areaColor: {
                                type: "linear",
                                x: 1200,
                                y: 0,
                                x2: 0,
                                y2: 0,
                                colorStops: [{
                                    offset: 0,
                                    color: "rgba(3,27,78,0.75)", // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: "rgba(58,149,253,0.75)", // 50% 处的颜色
                                },],
                                global: true, // 缺省为 false
                            },
                            borderColor: "#fff",
                            borderWidth: 0.2,
                        },
                    },
                    layoutCenter: ["50%", "50%"],
                    layoutSize: "180%",
                    animation: false,
                    markPoint: {
                        symbol: "none"
                    },
                    data: this.data,
                }
            ],
        };
      // 使用刚指定的配置项和数据显示图标
      myChart.setOption(option);
    }, 
    getRegions (){
       this.flowData =  this.toolTipData.map(element => {
          const { name} = element;
          return {
            name,
            label: {
                    normal: {
                        show: true,
                        textStyle: {
                            color: '#00AFAF'
                        }
                    },
                    emphasis: {
                        show: true,
                        textStyle: {
                            color: '#fff'
                        }
                    }
                },
            itemStyle: {
              normal: {
                label: {
                 show: true,
                 textStyle: {
                      olor: '#00AFAF'
                 }
 
                },
                areaColor: 'rgba(0, 175, 175, 0.15)',
                borderColor: '#00AFAF',
                borderWidth: 0.5,
                // shadowBlur: 10,
                // shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            emphasis:  { // 只有当有数据时才设置 emphasis
                areaColor: "00AFAF",
                itemStyle: {
                    areaColor: "#00AFAF", // 高亮时候地图显示的颜色
                    borderColor: "#4D4D4D", // 高亮时候地图边框的颜色
                    borderWidth: 0.5, // 高亮时的边框宽度
                  },
               label: {
                 show: true,
                 color: '#d9f3f3'
               }
             },
             select: {
                label: {
                  show: true,
                  color: '#fff'
                },
                itemStyle: {
                  areaColor: '#00afaf'
                }
            
              }, 
          };
        })
        // console.log(res)
        // console.log(this.flowData)
        
     
    
    },
    setOptionData(params,myChart){
        if (params.componentType === 'series' && params.seriesType === 'map') {
                let selectedName = params.name;
                let newLineData = this.lineData(this.geoCoordMap,this.toolTipData,selectedName ); // 获取新的线数据
                let newScatterData = this.scatterData(this.geoCoordMap,this.toolTipData,selectedName ); // 获取新的散点数据
            // console.log(newLineData,newScatterData);
                // 设置新的图表数据
                myChart.setOption({
                    series: [
                        {
                            name: 'lines',
                            type: 'line',
                            data: newLineData
                        },
                        {
                            name: 'scatter',
                            type: 'scatter',
                            data: newScatterData,
                          
                        }
                    ]
                });
            }
    },
    convertData() {
        var res = [];
        for (var i = 0; i < data.length; i++) {
            var geoCoord = this.geoCoordMap[this.data[i].name];
            if (geoCoord) {
                res.push({
                    name: this.data[i].name,
                    value: geoCoord.concat(this.data[i].value),
                });
            }
        }
        return res;
    },
    lineData(geoCoordMap,toolTipData,selectedName ){
        console.log(geoCoordMap,toolTipData,selectedName)

        return toolTipData.map((item) => {
             if (!selectedName || item.name === selectedName ||selectedName.includes(item.name)) {
console.log(item.name)
            
                 const data =   { coords: [geoCoordMap[item.name], [geoCoordMap[item.name][0], geoCoordMap[item.name][1] + 1.5]]}
                     if(data.coords.length === 2){
                        console.log( data.coords[1]    )
                         return data.coords[1]    
                     }
                
             }
             return null;
         }).filter(item => item !== null);
    },
    scatterData(geoCoordMap,toolTipData,selectedName ){
        return toolTipData.map((item) => {
            if (!selectedName || item.name === selectedName||selectedName.includes(item.name)) {
                return [geoCoordMap[item.name][0], geoCoordMap[item.name][1] + 2, item];
            }
            return null;
        }).filter(item => item !== null);
    }
  }
  
};


</script>